"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var is_node_1 = require("@reverbdotcom/commons/dist/is-node");
var curated_set_row_actions_1 = require("./actions/curated_set_row_actions");
var collection_header_store_1 = require("./stores/collection_header_store");
function buildParams(state) {
    var query = lodash_1.get(state, 'location.query') || {};
    var params = lodash_1.get(state, 'params') || {};
    return tslib_1.__assign(tslib_1.__assign({}, query), params);
}
function fetchCuratedSetRow(params) {
    curated_set_row_actions_1.default.fetch(params);
}
function fetchCollectionHeader(routerState) {
    var storeState = collection_header_store_1.CollectionHeaderStore.getState();
    var newParams = tslib_1.__assign(tslib_1.__assign({}, routerState.params), { 
        // We need query from qs params because marketplace searches hide the CH
        query: routerState.location.query.query });
    if (!lodash_1.isEqual(newParams, storeState.params)) {
        collection_header_store_1.CollectionHeaderActions.fetchOrClear(newParams);
    }
}
exports.fetchCollectionHeader = fetchCollectionHeader;
function fetch(newState, oldState) {
    if (is_node_1.default) {
        return;
    }
    var newParams = buildParams(newState);
    var oldParams = oldState && buildParams(oldState);
    if (lodash_1.isEqual(newParams, oldParams)) {
        return;
    }
    fetchCuratedSetRow(newParams);
    fetchCollectionHeader(newState);
}
exports.default = { fetch: fetch };
//# sourceMappingURL=default_grid_fetcher.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/default_grid_fetcher.js
// module id = yjtQ
// module chunks = 20 21